/* LL Scroll Reveal — lightweight IntersectionObserver */
(function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.ll-reveal,.ll-reveal--scale,.ll-reveal--left,.ll-reveal--right').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.ll-reveal,.ll-reveal--scale,.ll-reveal--left,.ll-reveal--right').forEach(function(el) {
    observer.observe(el);
  });
})();
